import Link from 'next/link'
import { useRouter } from 'next/router'

import ShoppingCart from '@/assets/icons/ShoppingCart'
import Icon from '@/components/Icon'
import { useAmplitude } from '@/contexts/AmplitudeProvider'
import { getDeviceId } from '@/services/amplitude/getDeviceId'
import { IconProps } from '@/types/cms'
import { sendEvent } from '@/utils/analytics'
import { getAllExperimentsAndVariants } from '@/utils/getAllExperimentsAndVariants'
import { getGaClientId } from '@/utils/getGaClientId'
import { getGASessionId } from '@/utils/getGASessionId'
import { handleLinkWithParamsFromCMS } from '@/utils/handleLinkWithParamsFromCMS'

const onClickOrderNow = () => {
  sendEvent({
    action: 'ADQUIRA',
    category: 'CTA_HEADER'
  })
}

interface CTAButtonProps {
  iconCTAButton?: IconProps
  textCTAButton?: string
  redirectCTAButton?: string
  className?: string
}

const CTAButton = ({
  className,
  redirectCTAButton,
  iconCTAButton,
  textCTAButton
}: CTAButtonProps) => {
  const router = useRouter()
  const { analytics } = useAmplitude()

  return (
    <Link
      onClick={(e) => {
        onClickOrderNow
        const textSection = (e.nativeEvent as unknown as { section: string })
          .section

        const textButton = (e.nativeEvent as unknown as { clicktext: string })
          .clicktext

        analytics?.track({
          event_type: 'cta ton',
          event_properties: {
            name: 'cta ton',
            section_reference: textSection,
            cross_lead_id: getGASessionId(),
            client_id_ga: getGaClientId(),
            user_agent: window?.navigator?.userAgent,
            category: `${e.currentTarget.href}`,
            cta_reference: textButton,
            source: router.pathname,
            experiments: JSON.stringify(getAllExperimentsAndVariants())
          },
          device_id: getDeviceId(),
          user_agent: window?.navigator?.userAgent
        })
      }}
      href={handleLinkWithParamsFromCMS({
        linkHref: redirectCTAButton,
        routeQuery: router.query
      })}
      aria-label={textCTAButton}
      className={`btn btn-primary btn-regular ${className}`}
    >
      {iconCTAButton ? (
        <Icon
          name={iconCTAButton.name}
          className="mr-8 text-current fill-current"
        />
      ) : (
        <ShoppingCart className="mr-8 text-current stroke-current" />
      )}
      <b className="font-bold">{textCTAButton}</b>
    </Link>
  )
}

export default CTAButton
